<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="waves_full_pages"></div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4">БЛОГ<br /></span>
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button data-action="toggleBig" class="button_v1">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <!-- <section class="section_button_blog">
    <div class="mobail_version">
      <button class="button_filter_open" @click="toggleFilter(1)">
        Отрасли
        <div class="box_img_bitton_open">
          <img
            :src="isFilterOpen === 1 ? closeImageSrc : openImageSrc"
            class="img_bitton_open"
          />
        </div>
      </button>
    </div>
    <div class="container_filter" :class="{ active: isFilterOpen === 1 }">
      <div class="box_filter">
        <button
          v-for="(button, index) in buttons"
          :key="index"
          class="filter_button"
          :class="{ active: activeButtons.includes(index) }"
          @click="handleClick(index)"
        >
          {{ button.text }}
        </button>
      </div>
    </div>

    <div class="box_button_blog">
      <button class="button_blog">Все статьи</button>
      <button class="button_blog">Разработка</button>
      <button class="button_blog">Дизайн</button>
      <button class="button_blog">Маркетинг</button>
      <button class="button_blog">Автоматизация</button>
    </div>
    <div class="container_search_blog">
      <div @click="toggleModal" ref="box_search_blog" class="box_search_blog">
        <img class="union_search" src="@/assets/elements/Union.svg" />
      </div>
      <div ref="box_search_blog_full" class="box_search_blog_full">
        <div class="box_left_search">
          <img class="union_search" src="@/assets/elements/Union.svg" />
          <input class="input_search" placeholder="Поиск" />
        </div>
        <img
          @click="closeModal"
          class="cross_search"
          src="@/assets/elements/cross.svg"
        />
      </div>
    </div>
  </section> -->
  <section class="section_blog_articles" v-if="articlesData.length >= 2">
    <router-link :to="articlesData[0].path" class="box_big_articles">
      <img
        :src="articlesData[0].image"
        class="big_img_articles"
        :alt="articlesData[0].title"
        loading="lazy"
      />
      <p class="font_1rem_400_Raleway color_violet">
        {{ articlesData[0].date }}
      </p>
      <h2 class="title_services_design">
        {{ articlesData[0].title }}
      </h2>
    </router-link>
    <div class="container_right_newsletter">
      <div class="box_right_newsletter">
        <!-- <div class="text_newsletter">
          <p class="title_services_design">Подпишись на нашу рассылку</p>
          <p class="font_1rem_400_Raleway color_violet">
            Мы отправляем полезные<br />
            материалы, которые помогут<br />
            вам в работе
          </p>
        </div>
        <div class="box_input_newsletter">
          <input v-model="email" class="input_newsletter" placeholder="Email" />
          <button class="button_newsletter" @click="handleSubmit">
            {{ isEmailValid ? "" : "ОК" }}
            <img
              v-if="isEmailValid"
              src="@/assets/elements/check_mark.svg"
              class="check_mark"
            />
          </button>
          <p v-if="showErrorMessage" class="error-message">
            Некорректный Email*
          </p>
        </div> -->
        <p class="title_services_design">Подпишись на наши соцсети</p>
        <p class="font_1_400_Kreadon_Regular color_violet">
          Мы отправляем полезные материалы, которые помогут вам в работе. Мы
          отправляем полезные материалы, которые помогут вам в работе
        </p>
        <div class="container_button_networks_articles">
          <div class="box_button_networks_articles">
            <a href="https://t.me/mti_dev" target="_blank" class="button_v1"
              >Telegram</a
            >
          </div>
          <div class="box_button_networks_articles">
            <a
              href="https://www.youtube.com/@mti-dev"
              target="_blank"
              class="button_v1"
              >Youtube</a
            >
          </div>
        </div>
      </div>
      <router-link :to="articlesData[1].path" class="box_articles">
        <img
          :src="articlesData[1].image"
          class="img_articles"
          :alt="articlesData[1].title"
          loading="lazy"
        />
        <p class="font_1rem_400_Raleway color_violet">
          {{ articlesData[1].date }}
        </p>
        <h2 class="input_search">
          {{ articlesData[1].title }}
        </h2>
      </router-link>
    </div>
    <router-link
      v-for="(article, index) in articlesData.slice(2)"
      :key="index"
      class="box_articles full_version"
      :to="article.path"
    >
      <img :src="article.image" class="img_articles" :alt="article.title" loading="lazy" />
      <p class="font_1rem_400_Raleway color_violet">
        {{ article.date }}
      </p>
      <h2 class="input_search">
        {{ article.title }}
      </h2>
    </router-link>
    <!-- <div class="box_right_newsletter mobail_version">
      <div class="text_newsletter">
        <p class="font_2_18_mobil">Подпишись на нашу рассылку</p>
        <p class="font_1rem_400_Raleway color_violet">
          Мы отправляем полезные<br />
          материалы, которые помогут<br />
          вам в работе
        </p>
      </div>
      <div class="box_input_newsletter">
        <input v-model="email" class="input_newsletter" placeholder="Email" />
        <button class="button_newsletter" @click="handleSubmit">
          {{ isEmailValid ? "" : "ОК" }}
          <img
            v-if="isEmailValid"
            src="@/assets/elements/check_mark.svg"
            class="check_mark"
          />
        </button>
        <p v-if="showErrorMessage" class="error-message">Некорректный Email*</p>
      </div>
    </div> -->
    <div class="box_right_newsletter mobail_version">
      <!-- <div class="text_newsletter">
          <p class="title_services_design">Подпишись на нашу рассылку</p>
          <p class="font_1rem_400_Raleway color_violet">
            Мы отправляем полезные<br />
            материалы, которые помогут<br />
            вам в работе
          </p>
        </div>
        <div class="box_input_newsletter">
          <input v-model="email" class="input_newsletter" placeholder="Email" />
          <button class="button_newsletter" @click="handleSubmit">
            {{ isEmailValid ? "" : "ОК" }}
            <img
              v-if="isEmailValid"
              src="@/assets/elements/check_mark.svg"
              class="check_mark"
            />
          </button>
          <p v-if="showErrorMessage" class="error-message">
            Некорректный Email*
          </p>
        </div> -->
      <p class="title_services_design">Подпишись на наши соцсети</p>
      <p class="font_1_400_Kreadon_Regular color_violet">
        Мы отправляем полезные материалы, которые помогут вам в работе. Мы
        отправляем полезные материалы, которые помогут вам в работе
      </p>
      <div class="container_button_networks_articles">
        <div class="box_button_networks_articles">
          <a href="https://t.me/mti_dev" target="_blank" class="button_v1"
            >Telegram</a
          >
        </div>
        <div class="box_button_networks_articles">
          <a
            href="https://www.youtube.com/@mti-dev"
            target="_blank"
            class="button_v1"
            >Youtube</a
          >
        </div>
      </div>
    </div>
    <router-link
      v-for="(article, index) in articlesData.slice(0)"
      :key="index"
      class="box_articles mobail_version"
      :to="article.path"
    >
      <img :src="article.image" class="img_articles" :alt="article.title" loading="lazy" />
      <p class="font_1rem_400_Raleway color_violet">
        {{ article.date }}
      </p>
      <h2 class="input_search">
        {{ article.title }}
      </h2>
    </router-link>
    <div class="box_margin_button_v3" v-if="hasMore">
      <div class="box_button_v3">
        <button class="button_v1" @click="showMoreArticles" :disabled="loadingMore">
          {{ loadingMore ? 'ЗАГРУЗКА...' : 'БОЛЬШЕ СТАТЕЙ' }}
        </button>
      </div>
    </div>
  </section>
  <FooterPages />
</template>
<script>
import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import { ref, onMounted } from "vue";
import { useHead } from "@vueuse/head";

export default {
  components: { HeaderPages, FooterPages },
  setup() {
    const articlesData = ref([]);
    const hasMore = ref(false);
    const loadingMore = ref(false);
    const fetchedCount = ref(0);

    function mapArticles(data) {
      return data.articles.map((a) => ({
        ...a,
        path: `/${a.slug}`,
        image: a.image ? `/article_illustrations/${a.image}` : '',
      }));
    }

    async function fetchArticles(offset, limit) {
      const res = await fetch(`/api/articles?offset=${offset}&limit=${limit}`);
      const data = await res.json();
      const mapped = mapArticles(data);
      fetchedCount.value = offset + mapped.length;
      hasMore.value = fetchedCount.value < data.total;
      return mapped;
    }

    const showMoreArticles = async () => {
      if (loadingMore.value || !hasMore.value) return;
      loadingMore.value = true;
      try {
        const more = await fetchArticles(fetchedCount.value, 9);
        articlesData.value = [...articlesData.value, ...more];
      } catch (e) {
        console.error('Failed to load more articles:', e);
      } finally {
        loadingMore.value = false;
      }
    };

    onMounted(async () => {
      try {
        articlesData.value = await fetchArticles(0, 8);
      } catch (e) {
        console.error('Failed to load articles:', e);
      }
    });

    useHead({
      title: "Блог - MTI-Dev",
      meta: [
        {
          name: "description",
          content:
            "Интересные статьи о разработке сайтов, UX/UI дизайне, SEO-продвижении и цифровых сервисах. Полезные советы, кейсы и тренды для успешного развития вашего бизнеса.",
        },
      ],
    });

    const email = ref("");
    const isEmailValid = ref(false);
    const showErrorMessage = ref(false);

    const validateEmail = () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isEmailValid.value = emailRegex.test(email.value);
    };

    const handleSubmit = () => {
      validateEmail();
      if (isEmailValid.value) {
        showErrorMessage.value = false;
      } else {
        showErrorMessage.value = true;
      }
    };

    return {
      email,
      isEmailValid,
      showErrorMessage,
      validateEmail,
      handleSubmit,
      articlesData,
      hasMore,
      loadingMore,
      showMoreArticles,
    };
  },
  methods: {
    toggleModal() {
      this.$refs.box_search_blog_full.classList.toggle("active");
      this.$refs.box_search_blog.classList.toggle("active");
    },
    handleClick(index) {
      if (this.activeButtons.includes(index)) {
        this.activeButtons = this.activeButtons.filter((i) => i !== index);
      } else {
        this.activeButtons.push(index);
      }
    },
    closeModal() {
      this.$refs.box_search_blog_full.classList.toggle("active");
      this.$refs.box_search_blog.classList.toggle("active");
    },
    toggleFilter(filterId) {
      if (this.isFilterOpen === filterId) {
        this.isFilterOpen = null;
      } else {
        this.isFilterOpen = filterId;
      }
    },
  },
  data() {
    return {
      activeButtons: [],
      buttons: [
        { text: "Все статьи" },
        { text: "Разработка" },
        { text: "Дизайн" },
        { text: "Дизайн" },
      ],
      openImageSrc: require("@/assets/elements/img_bitton_open.svg"),
      closeImageSrc: require("@/assets/elements/img_bitton_close.svg"),
      isFilterOpen: null,
    };
  },
};
</script>
<style scoped>
.box_right_newsletter {
  gap: 0.6rem;
}
.container_right_newsletter {
  gap: 3rem;
}
.section_blog_articles {
  justify-content: flex-start;
}
</style>
